<template>
  <a-form-item
    :label="varLabel"
    :label-col="formItemLayout.labelCol"
    :wrapper-col="formItemLayout.wrapperCol"
  >
    <a-input
      :size="size"
      :disabled="disabled"
      v-decorator="[varName, { 
                    rules: [{ required: varRequired, message: message, pattern: new RegExp(/^[A-Za-z0-9]+(?::[A-Za-z0-9]+)+$/)}],
                    initialValue: varInitial
                    }]"
      :placeholder="varLabel"
    />
    <a-alert  type="info" showIcon style="margin-top:5px;">
        <div slot="message">One or more alphanumeric strings separated by colon. Example: <a-tag color="pink">delete</a-tag><a-tag color="red">comment:read</a-tag><a-tag color="orange">blog:post:write</a-tag></div>
    </a-alert>
  </a-form-item>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  mixins: [formLayoutMixin],
  props: {
    varName: String,
    varLabel: String,
    varInitial: String,
    varRequired: Boolean,
    formLayout: String,
    description: [String, null],
    disabled: {
      type: Boolean,
      default: false
    },
    size: String
  },
  computed: {
    message() {
      return `Please enter valid ${this.varLabel.toLowerCase()}`;
    }
  }
};
</script>
